import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { TargetBuilder } from '../../models/builder/target.builder';

@Injectable()
export class TargetApiService {
  private apiUrl: string;

  constructor(
    private httpClient: HttpClient
  ) {
    this.apiUrl = `${ environment.companyAdmin.apiUrl }targets`;
  }

  getTargets() {
    return this.httpClient.get(`${ this.apiUrl }`)
      .pipe(map(TargetBuilder.fromList));
  }
}
